<template>
  <footer class="Footer">
    <div class="wrapper">
      <div class="Footer__inner">
        <nav class="Footer__layout Nav Nav_desktop">
          <Logo :logo="{ to: logo.to, image: logo.image.footer }" />

          <Share :icons="share.icons" wrapper="Nav" />
        </nav>
        <div class="Footer__extra">
          <p class="Footer__text">
            {{ websiteName }} - {{ $t("VUE.FOOTER_TEXT_1") }}
          </p>
        </div>
        <div class="Footer__copy">
          <div class="Footer__copy-right">
            <span>
              <i18n path="VUE.FOOTER_BY_SAILET.DESIGNED_BY">
                <template #developer>
                  <a href="https://sailet.pro/">Sailet</a>
                </template>
              </i18n>
            </span>
          </div>
          <div class="Footer__copy-link">
            <a
              href="https://web.telegram.org/#/im?p=@sailet_llp"
              target="_blank"
              rel="noreferrer nofollow"
            >
              <svg
                width="36"
                height="32"
                viewBox="0 0 36 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.622499 15.794L9.426 20.1815C9.7665 20.3495 10.1685 20.3375 10.494 20.147L18.33 15.5915L13.587 19.7945C13.3455 20.009 13.2075 20.315 13.2075 20.6375V30.875C13.2075 31.955 14.586 32.4095 15.2325 31.5515L19.038 26.492L28.449 31.8515C29.109 32.231 29.955 31.85 30.108 31.0955L35.9775 1.8455C36.153 0.966498 35.2785 0.249499 34.4655 0.576498L0.715499 13.739C-0.190501 14.093 -0.249001 15.3605 0.622499 15.794ZM33.3675 3.4205L28.209 29.126L19.2915 24.047C18.8055 23.7695 18.18 23.8925 17.835 24.3485L15.4575 27.509V21.143L28.284 9.779C29.2995 8.8805 28.1325 7.283 26.973 7.964L9.888 17.897L3.9 14.9135L33.3675 3.4205Z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <SharePopup />
      <MobileMenu />
      <template v-if="$route.name === 'helpcenter.project'">
        <RequestHelpForm />
        <UploadForm />
        <ComplainForm />
      </template>
    </div>
  </footer>
</template>

<script>
import {
  Logo,
  SharePopup,
  Share,
  RequestHelpForm,
  MobileMenu
} from "@/components/app";

export default {
  name: "Footer",
  data: () => ({
    share: {
      icons: [
        {
          src: require("@/assets/images/1PH2sk9KKpJNYT-baEFlpw.svg"),
          alt: "vk"
        },
        {
          src: require("@/assets/images/39bQ1s4_B8Uit750tn8fxk.svg"),
          alt: "facebook"
        },
        {
          src: require("@/assets/images/31iKawYVsldFlibQv6hKhf.svg"),
          alt: "linkedin"
        }
      ]
    }
  }),
  computed: {
    logo() {
      return this.$route.meta.logo;
    },
    websiteName() {
      return this.$route.name;
    }
  },
  components: {
    Logo,
    SharePopup,
    Share,
    RequestHelpForm,
    UploadForm: () => import("@/components/app/Forms/UploadForm"),
    ComplainForm: () => import("@/components/app/Forms/ComplainForm"),
    MobileMenu
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

/*<footer>*/
.Footer {
  color: $sec_c;
  background-color: $aux_bg;
  border-top-left-radius: 60px;

  &__layout {
    padding: 30px 0;
  }

  &__copy {
    display: flex;
    align-items: center;
    justify-content: center;

    &-right {
      a {
        color: $sec_c;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    &-link {
      margin: 0 0 0 20px;

      a {
        path {
          fill: $sec_c;
          transition: fill 0.2s;
        }

        &:hover {
          path {
            fill: rgba($sec_bg, 0.6);
          }
        }
      }
    }
  }

  &__extra,
  &__copy {
    margin: 30px 0 0;
  }

  .Nav {
    &__share {
      border-color: $sec_bg;

      span {
        color: $sec_c;
      }

      path {
        fill: $sec_c;
      }
    }
  }

  @media screen and (min-width: $min-lg) {
    &__text {
      width: 40%;
    }
  }

  @media screen and (min-width: $min-md) and (max-width: $max-md) {
    &__text {
      width: 60%;
    }
  }

  @media screen and (min-width: $min-md) {
    .Nav {
      justify-content: space-between;
    }
  }

  @media screen and (max-width: $max-sm) {
    &__layout {
      flex-direction: column;
    }

    .Nav {
      &__logo {
        justify-content: center;
      }
    }
  }
}
</style>
